import { z } from "zod";
import { api } from "./api";

export const subscriptionStatusSchema = z.enum(["disabled", "active", "overdue"]);
export type SubscriptionStatusSchema = z.infer<typeof subscriptionStatusSchema>;

export const customerSchema = z.object({
  id: z.string(),
  subscriptionStatus: subscriptionStatusSchema,
  subscriptionCancelsAt: z.string().nullable(),
  stripeCxId: z.string().nullable(),
  stripeSubscriptionId: z.string().nullable(),
  devicesStripeSubscriptionItemId: z.string().nullable(),
  medicalStripeSubscriptionItemId: z.string().nullable(),
});
export type Customer = z.infer<typeof customerSchema>;

const CUSTOMER_URL = `/dash/customer`;

export async function getCustomer(): Promise<Customer> {
  const resp = await api.get(CUSTOMER_URL);
  if (!resp.data) throw new Error(`Didnt return customer`);
  return customerSchema.parse(resp.data);
}

export default api;
